define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ConferenceType = void 0;
    var ConferenceType;
    (function (ConferenceType) {
        ConferenceType["TEST_ROOM"] = "testRoom";
        ConferenceType["MAIN_ROOM"] = "mainRoom";
    })(ConferenceType = exports.ConferenceType || (exports.ConferenceType = {}));
});
